import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import $ from 'jquery'
import { connect } from 'react-redux';
import { semanticColors } from '../../../Globals/styles';
import SuggestSelectInput from '../../../Common/suggestSelectInput';
import RangeDatePicker from '../../../Common/rangeDatePicker';
import { routeActions } from 'redux-simple-router';
import { httpGet } from '../../../Util/http';
import {
  attemptFetchProjects,
  addProject,
  getSuggestions,
  setProjectIsSelected,
  setSalaryDates,
  removeProject
} from './actions'
import SalaryFeed from './SalaryFeed';

class CreateSalary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestSelectInputVal: { name: null, id: null },
      departmentSuggestSelectInputVal: { name: null, id: null },
      afdeling: true,
      departments: [],
      projects: []
    }
  }
  componentWillMount = () => {
    if (!this.props.projects.length) {
      this.props.dispatch(attemptFetchProjects())
    }
  };
  componentDidMount() {
    this.getDepartments()
  }
  getDepartments = async () => {
    var _url = process.env.REACT_APP_webApiEndPoint + `api/department`;
    httpGet(_url)
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        this.setState({
          departments: json
        })
      })
      .catch(() => {
        alert('Kunne ikke hente afdelinger')
      });
  };
  setDates = (startDate, endDate) => {
    this.props.dispatch(setSalaryDates(startDate, endDate))

    if (this.state.departmentSuggestSelectInputVal.id && startDate && endDate) {
      httpGet(process.env.REACT_APP_webApiEndPoint + `api/salary/${this.state.departmentSuggestSelectInputVal.id}?dateFrom=${JSON.parse(JSON.stringify(startDate))}&dateTo=${JSON.parse(JSON.stringify(endDate))}`)
        .then(response => {
          return response.json();
        })
        .then((json) => {
          this.setState({
            projects: json.projects.map(proj => ({ ...proj, isSelected: true }))
          })
        })
        .catch(() => {
          alert('fejl')
        })
    }
  };
  isButtonActive = () => {
    const { startDate, endDate } = this.props;
    if (this.state.afdeling) {
      return startDate && endDate && this.state.projects.some( pr => pr.isSelected)
    }
    return startDate && endDate && this.shouldChooseAll
  };
  onSuggestInputChange = (val) => {
    if (val.id) {
      this.setState({
        suggestSelectInputVal: { name: null, id: null }
      })
      this.props.dispatch(addProject(val));
    }
    else {
      this.setState({
        suggestSelectInputVal: val
      })
    }
  };
  onDepartmentSuggestInputChange = (val) => {
    const { startDate, endDate } = this.props;
    if (val.id && startDate && endDate) {
      httpGet(process.env.REACT_APP_webApiEndPoint + `api/salary/${val.id}?dateFrom=${JSON.parse(JSON.stringify(startDate))}&dateTo=${JSON.parse(JSON.stringify(endDate))}`)
        .then(response => {
          return response.json();
        })
        .then((json) => {
          this.setState({
            projects: json.projects.map(proj => ({ ...proj, isSelected: true }))
          })
        })
        .catch(() => {
          alert('fejl')
        })
    }
    this.setState({
      departmentSuggestSelectInputVal: val
    })
  }
  onProjectClick = (projectIndex) => {
    const { dispatch, projects } = this.props;
    if (this.state.afdeling) {
      const newPr = [...this.state.projects]
      newPr[projectIndex] = { ...newPr[projectIndex], isSelected: !newPr[projectIndex].isSelected }
      this.setState({
        projects: newPr
      })
    } else (
      dispatch(setProjectIsSelected(projectIndex, !projects[projectIndex].isSelected))
    )
  };
  shouldChooseAll = () => {
    let result = true;
    this.props.projects.forEach((project) => {
      if (project.isSelected) result = false;
    })
    return result
  };
  chooseAll = () => {
    const { dispatch, projects } = this.props;
    projects.forEach((project, index) => {
      if (!project.isSelected)
        dispatch(setProjectIsSelected(index, true))
    })
  };
  removeAll = () => {
    const { dispatch, projects } = this.props;
    projects.forEach((project, index) => {
      if (project.isSelected)
        dispatch(setProjectIsSelected(index, false))
    })
  };
  onSubmit = async () => {
    // 
    const { dispatch, projects, startDate, endDate } = this.props;
    let projz = projects
    if(this.state.afdeling) {
      projz = this.state.projects
    }
    $(this.refs.submitButton).html('<i class="fa fa-spinner fa-spin" style="font-size: 20px;"/>');
    let chosenProjects = []
    projz.forEach((project) => {
      if (project.isSelected) chosenProjects.push(project.id)
    })
    setTimeout(() => {
      let jsonString = JSON.stringify({ projectIds: chosenProjects, startDate: startDate, endDate: endDate });
      dispatch(routeActions.push("/lon?obj=" + jsonString))
    }, 200)

  };
  render() {
    const { projectSuggestions, projects, dispatch, startDate } = this.props;
    let projNo = projects;
    if (this.state.afdeling) {
      projNo = this.state.projects
    }
    let projectNodes = projNo.map((project, index) => {
      return (
        <div key={project.id} onClick={() => this.onProjectClick(index)} className="row" style={styles.projectRow}>
          <div className="col-xs-10">
            <div style={[styles.name, project.isSelected && styles.nameActive]}>
              {project.name}
            </div>
          </div>
          <div style={styles.checkContainer} className="col-xs-2">
            {project.isSelected ? <i className="fa fa-check-square-o" aria-hidden="true"></i> : <i className="fa fa-square-o" aria-hidden="true" style={{ paddingRight: 2 }}></i>}
            {this.state.afdeling ? null :
              <i className="fa fa-trash-o" aria-hidden="true" style={{ paddingLeft: 10 }} onClick={(e) => {
                e.stopPropagation()
                this.props.dispatch(removeProject(project.id, index, project.isSelected))
              }}></i>
            }
          </div>
        </div>
      )
    })
    return (
      <div>
      <div style={styles.container} className="row">
        <div className="col-md-4">
          <h2>Periode</h2>
          <div style={[styles.innerContainer, styles.rightContainer]}>
            <div style={styles.datePickerContainer}>
              <RangeDatePicker
                defaultStartDate={startDate}
                onChange={this.setDates}
              />
            </div>

            <button
              ref="submitButton"
              style={styles.submitButton}
              onClick={this.onSubmit}
              disabled={!this.isButtonActive()}
              className={this.isButtonActive() ? "btn btn-primary" : "btn btn-default"}>
              Vis Lønliste
            </button>
          </div>

        </div>
        <div style={styles.leftOuterContainer} className="col-md-7 col-md-offset-1">
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
            <h2 onClick={() => this.setState({ afdeling: true })} style={{ cursor: 'pointer', textDecoration: this.state.afdeling ? "underline" : "none" }}>Afdeling</h2>
            <h2 onClick={() => this.setState({ afdeling: false })} style={{ cursor: 'pointer', textDecoration: !this.state.afdeling ? "underline" : "none" }}>Sager</h2>
          </div>
          {this.state.afdeling ?
            <div>
              <div style={[styles.innerContainer, styles.leftContainer]}>
                <div className="row" style={styles.inputRow}>
                  <div className="col-xs-10">
                    <SuggestSelectInput
                      onChange={this.onDepartmentSuggestInputChange}
                      onQuery={(q) => console.log('mute')}
                      suggestions={this.state.departments.filter(d => d.name.toLowerCase().includes(this.state.departmentSuggestSelectInputVal.name && this.state.departmentSuggestSelectInputVal.name.toLowerCase()))}
                      value={this.state.departmentSuggestSelectInputVal}
                      placeholder="Vælg Afdeling"
                    />
                  </div>
                </div>
                {projectNodes}
              </div>
            </div>
            :
            <div style={[styles.innerContainer, styles.leftContainer]}>
              <div className="row" style={styles.inputRow}>
                <div className="col-xs-10">
                  <SuggestSelectInput
                    onChange={this.onSuggestInputChange}
                    onQuery={(q) => dispatch(getSuggestions(q))}
                    suggestions={projectSuggestions || []}
                    value={this.state.suggestSelectInputVal}
                    placeholder="Vælg sag"
                  />
                </div>

                {this.shouldChooseAll() ?
                  <div style={[styles.checkContainer, styles.chooseAllCheck]} onClick={this.chooseAll} className="col-xs-2">
                    <i className="fa fa-square-o" aria-hidden="true"></i>
                    <span style={styles.chooseAllText}>vælg alle</span>
                  </div>
                  :
                  <div style={[styles.checkContainer, styles.chooseAllCheck]} onClick={this.removeAll} className="col-xs-2">
                    <i className="fa fa-check-square-o" aria-hidden="true"></i>
                    <span style={styles.chooseAllText}>fravælg alle</span>
                  </div>
                }

              </div>
              {projectNodes}
            </div>
          }

   
        </div>
      </div>
       <SalaryFeed onClick={(ev) => {
        setTimeout(() => {
            let jsonString = JSON.stringify({ projectIds: ev.data.projectIds, startDate: ev.data.dateFrom, endDate: ev.data.dateTo });
            dispatch(routeActions.push("/lon?obj=" + jsonString))
        }, 200)
      }} />
      </div>
    );
  }
}

var styles = {
  container: {
    backgroundColor: semanticColors.default,
    padding: '30px 0 50px 0',
    textAlign: 'center',
    borderRadius: '2px',
    marginTop: '50px'
  },
  innerContainer: {
    marginTop: '30px'
  },
  leftOuterContainer: {
    paddingRight: 0
  },
  leftContainer: {
    minHeight: '700px',
    borderRight: '1px solid ' + semanticColors.mainBackground
  },
  inputRow: {
    marginBottom: '12px',
    fontSize: '16px',
    lineHeight: '35px',
    textAlign: 'left'
  },
  chooseAllText: {
    fontSize: '12px',
    paddingLeft: '5px'
  },
  projectRow: {
    cursor: 'pointer',
    textAlign: 'left',
    marginBottom: '2px',
    height: '40px',
    lineHeight: '40px',
    fontSize: '16px',
    userSelect: 'none'
  },
  name: {
    borderRadius: '2px',
    padding: '0 10px',
    fontSize: '14px'
  },
  nameActive: {
    backgroundColor: semanticColors.infoLighter
  },
  datePickerContainer: {
    display: 'inline-block'
  },
  submitButton: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '150px',
    width: '50%'
  },
  chooseAllCheck: {
    cursor: 'pointer',
    userSelect: 'none',
    height: '35px',
    overflow: 'hidden'
  },
  checkContainer: {
    paddingLeft: '5px'
  },
  isLoading: {
    fontSize: '20px'
  }
}

const selectProps = state => {
  return {
    ...state.createSalaryReducer
  };
}
CreateSalary.propTypes = {
  dispatch: PropTypes.func.isRequired,
  projects: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    isSelected: PropTypes.bool.isRequired
  })).isRequired,
  projectSuggestions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })).isRequired,
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date)
};
export default connect(selectProps)(Radium(CreateSalary));


// WEBPACK FOOTER //
// ./src/App/Project/Salary/CreateSalary/index.jsx